import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import cartService from '../../../services/cart';
import { setCart } from '../../../slices/cart';
import { CartInStore } from '../../../slices/cart/types';
import { getAPIErrorMessage } from '../../../utils';

const CART_NOT_FOUND_STATUS = '404';

const useGetActiveCart = ({
  cartId,
  isDraft = false,
}: { cartId?: string; isDraft?: boolean } = {}) => {
  const dispatch = useDispatch();   
  const cart = useSelector((state: { cart: CartInStore }) => state.cart);

  return useQuery({
    queryKey: ['getActiveCart', cartId],
    queryFn: async () => {
      
      if(isDraft) {
        return { ...cart, isDraft:true, status: 'succeeded' };
      }
      try {
        dispatch(setCart({ status: 'loading' }));
        const getActiveCartResponse = await cartService.getActiveCart();
        dispatch(
          setCart({
            ...getActiveCartResponse,
            previousLineItems: getActiveCartResponse?.lineItems || [],
            previousCustomLineItems:
              getActiveCartResponse?.customLineItems || [],
            isDraft: getActiveCartResponse?.isDraft || false,
            status: 'succeeded',
          }),
        );
        return getActiveCartResponse;
      } catch (error) {
        try {
          if (
            getAPIErrorMessage(error)?.apiErrors?.find(
              (apiError) => apiError.status === CART_NOT_FOUND_STATUS,
            )
          ) {
            dispatch(setCart({ status: 'succeeded' }));
            return { ...cart, status: 'succeeded' };
          }
          dispatch(setCart({ status: 'failed' }));
          return { ...cart, status: 'failed' };
        } catch (_error) {
          dispatch(setCart({ status: 'failed' }));
          return { ...cart, status: 'failed' };
        }
      }
    },
  });
};

export default useGetActiveCart;
